/**
 * Resolution Outcome Templates
 * Collection of pre-written resolution templates for admins to use when resolving disputes
 */

export const resolutionTemplates = [
    {
        id: 'favor_filer_full',
        outcome: 'favor_filer',
        title: 'In Favor of Filer - Full Refund',
        details: 'After careful review of all evidence and communications, we have decided in favor of the filer. A full refund will be processed within 5-7 business days. The item should be returned to the seller if applicable.'
    },
    {
        id: 'favor_filer_partial',
        outcome: 'favor_filer',
        title: 'In Favor of Filer - Partial Refund',
        details: 'After reviewing the evidence, we have decided in favor of the filer. A partial refund of [amount] will be processed within 5-7 business days. This resolution takes into account the circumstances of both parties.'
    },
    {
        id: 'favor_respondent_full',
        outcome: 'favor_respondent',
        title: 'In Favor of Respondent - No Refund',
        details: 'After careful review of all evidence and communications, we have decided in favor of the respondent. The transaction was completed as described, and no refund will be issued. The dispute is closed in favor of the seller.'
    },
    {
        id: 'favor_respondent_partial',
        outcome: 'favor_respondent',
        title: 'In Favor of Respondent - Partial Refund',
        details: 'After reviewing the evidence, we have decided in favor of the respondent. However, as a gesture of goodwill, a partial refund of [amount] will be processed. The dispute is resolved in favor of the seller.'
    },
    {
        id: 'partial_refund_standard',
        outcome: 'partial_refund',
        title: 'Partial Refund - Standard',
        details: 'After reviewing all evidence from both parties, we have determined that a partial refund is appropriate. A refund of [amount] will be processed within 5-7 business days. This resolution reflects the circumstances of the case.'
    },
    {
        id: 'partial_refund_damage',
        outcome: 'partial_refund',
        title: 'Partial Refund - Item Damage',
        details: 'The item was received with some damage that was not fully disclosed. We are issuing a partial refund of [amount] to compensate for the damage. The refund will be processed within 5-7 business days.'
    },
    {
        id: 'full_refund_standard',
        outcome: 'full_refund',
        title: 'Full Refund - Standard',
        details: 'After reviewing the dispute, we have determined that a full refund is warranted. The full amount will be refunded to your original payment method within 5-7 business days. Please return the item if applicable.'
    },
    {
        id: 'full_refund_not_received',
        outcome: 'full_refund',
        title: 'Full Refund - Item Not Received',
        details: 'The item was not received as expected. A full refund will be processed within 5-7 business days. We apologize for the inconvenience. If the item arrives later, please contact us immediately.'
    },
    {
        id: 'full_refund_wrong_item',
        outcome: 'full_refund',
        title: 'Full Refund - Wrong Item',
        details: 'The wrong item was received. A full refund will be processed within 5-7 business days. Please return the incorrect item if you wish. We apologize for the error and any inconvenience caused.'
    },
    {
        id: 'replacement_standard',
        outcome: 'replacement',
        title: 'Replacement - Standard',
        details: 'We have approved a replacement for the item. A new item will be shipped to you within 3-5 business days. You will receive tracking information once the replacement is shipped. Please return the original item if applicable.'
    },
    {
        id: 'replacement_damaged',
        outcome: 'replacement',
        title: 'Replacement - Damaged Item',
        details: 'The item arrived damaged. We have approved a replacement item which will be shipped to you within 3-5 business days. Please return the damaged item using the provided return label. We apologize for the inconvenience.'
    },
    {
        id: 'replacement_defective',
        outcome: 'replacement',
        title: 'Replacement - Defective Item',
        details: 'The item received was defective. We have approved a replacement which will be shipped to you within 3-5 business days. Please return the defective item. We apologize for the quality issue.'
    },
    {
        id: 'no_action_standard',
        outcome: 'no_action',
        title: 'No Action Required - Standard',
        details: 'After reviewing all evidence and communications, we have determined that no action is required. The transaction was completed as described and both parties fulfilled their obligations. The dispute is closed with no further action needed.'
    },
    {
        id: 'no_action_resolved',
        outcome: 'no_action',
        title: 'No Action Required - Already Resolved',
        details: 'This dispute has been resolved between the parties. No further action is required from our side. The case is closed. If you have any further concerns, please contact our support team.'
    },
    {
        id: 'cancelled_standard',
        outcome: 'cancelled',
        title: 'Cancelled - Standard',
        details: 'This dispute has been cancelled. The transaction will proceed as originally agreed. If you have any concerns, please contact our support team for assistance.'
    },
    {
        id: 'cancelled_mutual',
        outcome: 'cancelled',
        title: 'Cancelled - Mutual Agreement',
        details: 'This dispute has been cancelled by mutual agreement between both parties. The case is closed. If you need any further assistance, please contact our support team.'
    }
];

